import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface Notification {
  _id: string;
  title?: string;
  message: string;
  type?: string;
  isRead: boolean;
  createdAt: string;
  link?: string;
}

export interface NotificationsResponse {
  data: Notification[];
  totalUnread?: number;
  pages?: number;
  currentPage?: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly base = `${environment.api.baseUrl}/notifications`;

  constructor(private http: HttpClient) {}

  getNotifications(page = 1, limit = 4): Observable<NotificationsResponse> {
    return this.http.get<NotificationsResponse>(`${this.base}?page=${page}&limit=${limit}`);
  }

  getNotification(id: string): Observable<{ data: Notification }> {
    return this.http.get<{ data: Notification }>(`${this.base}/${id}`);
  }

  markAllAsRead(): Observable<any> {
    return this.http.patch(`${this.base}/read-all`, {});
  }

  markAsRead(id: string): Observable<any> {
    return this.http.patch(`${this.base}/${id}/read`, {});
  }
}
